<script setup>
import { Handle } from '@vue-flow/core'

import { useRegistryStore } from '@/stores/registry.store'

const registryStore = useRegistryStore()

defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  targetPosition: { type: String, required: true },
  sourcePosition: { type: String, required: true },
  selected: { type: Boolean, default: false },
  typeLabel: { type: String, required: true },
  typeColor: { type: String, required: true },
})

const getCustomerName = (customerId) => {
  if (!customerId) return ''
  const customer = registryStore.customers.find(c => c.id === customerId)
  return customer ? `${customer?.code} - ${customer?.name}` : ''
}
</script>

<template>
  <Handle
    type="target"
    :position="targetPosition"
  />
  <div
    class="doc-node"
    :class="{ 'doc-node--selected': selected }"
    :style="{ borderColor: typeColor }"
  >
    <div
      class="doc-node-header"
      :style="{ backgroundColor: typeColor }"
    >
      {{ typeLabel }}
    </div>
    <div class="doc-node-body">
      <span class="doc-node-identifier">{{ data.series }}/{{ data.number_mnemonic }}</span>
      <span class="doc-node-date">{{ data.date }}</span>
      <span class="doc-node-customer">{{ getCustomerName(data.customer) }}</span>
      <span class="doc-node-amount">
        {{ data.total_vat?.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }}
      </span>
    </div>
  </div>
  <Handle
    type="source"
    :position="sourcePosition"
  />
</template>

<style scoped lang="scss">
.doc-node {
  background: white;
  border: 0.125rem solid #ccc;
  border-radius: 0.5rem;
  min-width: 11rem;
  box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.12);
  cursor: pointer;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.1s;

  &:hover {
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  }

  &--selected {
    box-shadow: 0 0 0 0.1875rem rgba(33, 150, 243, 0.5), 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
}

.doc-node-header {
  color: white;
  font-size: 0.625rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  text-align: center;
  letter-spacing: 0.02em;
}

.doc-node-body {
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.doc-node-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
}

.doc-node-identifier {
  font-size: 0.75rem;
  font-weight: 700;
  color: #222;
  white-space: nowrap;
}

.doc-node-date {
  font-size: 0.625rem;
  color: #888;
  white-space: nowrap;
}

.doc-node-customer {
  font-size: 0.625rem;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.doc-node-amount {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  align-self: center;
}

.vue-flow__handle {
  height:8px;
  width:24px;
  border-radius:4px;
  border: 0;
  border: transparent;
  color: transparent;
  background-color: transparent;
}
</style>
